import React, { useState } from "react";
import { IOSSwitch } from "../../../../components/redesign-components/IOSSwitch/IOSSwitch";

export const PeriodSwitch = ({ isMonthly, onClick }) => {
  return (
    <div className="mb-12 flex items-center justify-center text-center">
      <span className="mr-6 text-sm font-semibold text-gray700">Monthly</span>
      <IOSSwitch checked={!isMonthly} onChange={onClick} />
      <span className="text-sm font-semibold text-gray700">Annually</span>
    </div>
  );
};
